export const DashboardCompareDutch = (text, type, section) => {
  switch (section) {
    case "compare-heading-info":
      return "Vergelijk hoe de leiders en parochianen de parochie zien.";
    case "holy-spirit":
      return "Heilige Geest";
    case "evangelization":
      return "Evangeisatie";
    case "leadership":
      return "Leiders"
    case "leaders":
      return "Leiders"
    case "parishioners":
      return "Parochianen"
    case "experience-of-the-holy-spirit":
      return "Ervaring van de Heilige Geest"
    case "asking-and-discerning-in-faith":
      return "Vragen en onderscheiden in geloof"
    case "responding-in-faith":
      return "Vol geloof reageren"
    case "resources-aligned":
      return "Besteding middelen"
    case "primacy-of-programs":
      return "Voorrang voor trajecten"
    case "cultural-reinforcement":
      return "Cultuurversterking"
    case "cultural-reinforcement-mobile":
      return "Cultuurver sterking"
    case "vision":
      return "Visie"
    case "planning-and-priorities":
      return "Planning en prioriteiten"
    case "leading-out-of-a-team":
      return "Leiden vanuit een team"
    case "growing-leadership-skills":
      return "Groeiende leiderschapsvaardigheden"
    case "growing-leadership-skills-mobile":
      return "Groeiende leiderschapsvaar digheden"
    case "not-enough-leaders-or-parishioners" :
      return "Nodig uw parochianen en leiders uit om de vragenlijst in te vullen om hun resultaten te bekijken."
    case "my-parish":
      return "Mijn Parochie"
    case "my-results":
      return "Mijn resultaten"
    case "percent-change":
      return "% Verandering"
    case "see-compare-heading-info":
      return "Bekijk hoe uw parochie zich verhoudt tussen twee willekeurige beoordelingen."
    case "assessments":
      return "Beoordelingen"
    case "date":
      return "Datum"
    case "note":
      return "Opmerking: Er kunnen slechts 2 beoordelingen tegelijk worden geselecteerd."
    case "compare":
      return "Vergelijk"
    case "active":
      return "Actief"
    case "respondents":
      return "RESPONDENTEN"
    case "priest":
      return "Priester"
    case "priests":
      return "Priesters"
    case "leader":
      return "Leider"
    case "leaders":
      return "Leiders"
    case "parishioner":
      return "Parochiaan"
    case "parishioners":
      return "Parochianen"
    case "loading-assessment-data":
      return "Beoordelingsgegevens worden geladen..."
    case "overview-not-available":
      return "Overzicht is nog niet beschikbaar"
    case "comparison-not-available":
      return "Vergelijking is nog niet beschikbaar"
    case "side-by-side-insights":
      return "Zodra u een andere beoordeling start, ziet u hier naast elkaar geplaatste inzichten."
    case "create-new-assessment":
      return "Nieuwe beoordeling aanmaken"
    case "no-data-available":
      return "Geen gegevens beschikbaar"
    case "no-data-message":
      return "Geen gegevens om te tonen. Kies een andere beoordeling."
    default:
      return text;
  }
}